import { Stack } from '@chakra-ui/react';

import { CreditCardPayment } from './components/CreditCardPayment';
import { Errors } from './components/Errors';
import { IbanPayment } from './components/IbanPayment';

const Payment = () => {
  return (
    <Stack spacing="space-16">
      <Errors />
      <CreditCardPayment />
      <IbanPayment />
    </Stack>
  );
};

export default Payment;
